import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledPlaceholder = styled(Text)<{ $show?: boolean }>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 16px;
	text-align: center;
	color: #ffffff;
	opacity: ${(props) => (props.$show ? 0.25 : 0)};
	transition:
		color 0.3s ease,
		opacity 0.3s ease;
	pointer-events: none;

	span {
		opacity: 0.5;
	}
`;

const StyledPlaceholderContainer = styled.div`
	position: relative;

	div:first-child:hover
		+ ${StyledPlaceholder},
		&:focus-within
		${StyledPlaceholder} {
		color: #000000;
	}
`;

export { StyledPlaceholderContainer, StyledPlaceholder };
